import { createStandardMenuItems, Menu } from "@msuite/ui/menu";
import { type CellContext, RowActionsWrapper } from "@msuite/ui/table";
import type { SuborderListItem } from "@msuite/utils/types";

export function RowActions({ cell }: CellContext<SuborderListItem, "actions">) {
	/** Computed */
	const { orderId, id } = cell.row.original;

	/** Render */
	return (
		<RowActionsWrapper to={`/orders/${orderId}/suborders/${id}`}>
			<Menu items={createStandardMenuItems({})}>
				<Menu.Button />
			</Menu>
		</RowActionsWrapper>
	);
}
